/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Featured_BadgeInputs */

const zh_featured_badge = /** @type {(inputs: Featured_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`精选案例`)
};

const en_featured_badge = /** @type {(inputs: Featured_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Featured Examples`)
};

const es_featured_badge = /** @type {(inputs: Featured_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejemplos destacados`)
};

/**
* | output |
* | --- |
* | "Featured Examples" |
*
* @param {Featured_BadgeInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const featured_badge = /** @type {((inputs?: Featured_BadgeInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Featured_BadgeInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_featured_badge(inputs)
	if (locale === "en") return en_featured_badge(inputs)
	return es_featured_badge(inputs)
});